import React from 'react';
import {CasinofiedApplicationBase} from "../casinofied-application-base";
import {IOpenAppData} from "@sparkware/uc-sdk-core";
import {ICasinofiedComponentFactory} from "../../casinofied-app-factory.interfaces";
import {CasinofiedAppSdkLoader} from "../../casinofied-app-sdk-loader";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {PaymentsRedirectFocusComponent} from "../../../../../components/payments-redirect-focus/payments-redirect-focus.component";
import {IModalDialogHandler} from "../../../../dialog/dialog.service.interface";
import {ICasinofiedApplicationAdapter} from "../adapters/casinofied-application-adapter.interface";
import {DISPLAY_MESSAGE_IDS} from "../../../../../../common/const/casinofied-analytics-consts";
import {Check} from "@sparkware/app-utils";
import {UnifiedCashierZoidAdapter} from "../adapters/unified-cashier-zoid-adapter";

export class PaymentsRedirectApplication extends CasinofiedApplicationBase {
    public constructor(openAppData: IOpenAppData,
                       componentFactory: ICasinofiedComponentFactory,
                       appSdkLoader: CasinofiedAppSdkLoader,
                       services: IServiceFactoryExtended) {
        super(openAppData, componentFactory, appSdkLoader, services, true);
    }

    private _focusDialogHandler: IModalDialogHandler = null;
    private _containerElement: Element = null;
    open(): Promise<void> {
        this._containerElement = this.services.dom.createElement('div');
        this._containerElement.id = this.openAppData.launchInfo.containerID;
        this.services.dom.body.appendChild(this._containerElement);
        return super.open().then(() => {
            this.services.casinofiedAnalytics.messageDisplay({
                displayMessageID: DISPLAY_MESSAGE_IDS.psRedirectFocusDialog,
                businessCorrelationID: this._openAppData.launchInfo.businessCorrelationID
            });

            this._focusDialogHandler = this.services.dialog.showModal(() => {
                return (<PaymentsRedirectFocusComponent redirectApp={this}/>)
            }, {
                title: this.services.translation.translate("PAYMENTS_REDIRECT_FOCUS_TITLE"),
                icon: this.services.theme.currentTheme.icons.paymentsRedirectIcon,
                hideCloseButton: true,
                isHighPriority: true,
                forceCentralization: true,
                mobileCenterHeader: true,
                forceTransparentBackground: true,
                disableFullscreenMobile: true
            });
        });
    }

    focus() {
        this.services.casinofiedAnalytics.messageActionTaken({
            businessCorrelationID: this._openAppData.launchInfo.businessCorrelationID,
            actionType: 'focus',
            sendLogLevelOnly: true
        });

        this._applicationAdapter.focus();
    }

    dispose() {
        super.dispose();
        this._containerElement?.remove();
        this._focusDialogHandler?.close();
    }

    get mftName(): string {
        const mftName = this._openAppData.launchInfo.appSpecificParameters["mft"];

        return Check.isNullOrUndefined(mftName) ? "" : mftName;
    }

    protected _createApplicationAdapter(appObject: any): ICasinofiedApplicationAdapter {
        return new UnifiedCashierZoidAdapter(this.appId, appObject);
    }
}